import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Getter, } from 'vuex-class';

import header from '@/views/layout/header/header.vue';
import sider from '@/views/layout/sider-menu/sider-menu.vue';


@Component({
  components: {
    'spare-header': header,
    'spare-sider': sider
  }
})
export default class Layout extends Vue {
  private defaultActive: string = ''; // 默认选中菜单
  private matched: object[] = [];
  @Watch('$route')
  private routeChange() {
    this.matched = this.$route.matched.map(v => (
      { path: v.path, title: v.meta.title
      })
    );
    this.defaultActive = this.$route.matched[1].path as string;
  }

  private mounted() {
    this.routeChange();
  }
}
